export default [
  {
    type: 'NOT_ENOUGH_DEALS',
    title: 'Not enough cooks where I live'
  },
  {
    type: 'TECHNICAL_PROBLEMS',
    title: 'Technical problems with the app'
  },
  {
    type: 'BAD_EXPIRIENCE',
    title: 'Bad customer experience'
  },
  {
    type: 'MOVING',
    title: 'Moving to a different city'
  },
  {
    type: 'OTHER',
    title: 'Other'
  }
]
